(function() {

    'use strict';

    angular.module('Services').factory('FleetVehicleTypesTableService', FleetVehicleTypesTableService);

    function FleetVehicleTypesTableService($location, FleetService, TableLiteFactory, toastr, Units, $rootScope) {
        return function () {
            let measureUnit = Units.getMeasureUnit($rootScope.GlobalProfile.office.measureUnit);
            measureUnit = measureUnit && measureUnit === 'CM' ? 'M' : 'FT';
            const tableData = {
                tableName: 'VehicleTypesTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Create New',
                        tooltip: 'Create New Vehicle Type',
                        onClick: function(){
                            $location.path('/fleets/vehicle-types/add');
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'Vehicle Type Code',
                    viewName: 'code',
                    filterName: 'code',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Vehicle Type Name',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Description',
                    viewName: 'description',
                    filterName: 'description',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Wheel Base',
                    viewName: 'wheelBaseFormatted',
                    filterName: 'wheelBase',
                    /*filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },*/
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Max Weight (KG)',
                    viewName: 'maxWeightFormatted',
                    filterName: 'maxWeight',
                    /*filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },*/
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Active', 'Inactive'],
                        onSelect: function(header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model === 'Active';
                            sendRequest(filter);
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, ],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: FleetService.VehicleTypes.getAll,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if(!data)
                    return null;
                angular.forEach(data.content, function(vehicleType, index) {
                    vehicleType.status = {
                        type: 'status',
                        status: vehicleType.active,
                        label: vehicleType.active ? 'Active' : 'Inactive'
                    };
                    vehicleType.wheelBaseFormatted = `${vehicleType.wheelBase} ${measureUnit}`;
                    vehicleType.maxWeightFormatted = `${vehicleType.maxWeight} ${Units.getWeightUnit($rootScope.GlobalProfile.office.weightUnit)}`;
                    vehicleType.href = '/fleets/vehicle-types/details/' + vehicleType.id;

                    tableData.data.push(vehicleType);
                });
                /*** END - Building of Data ***/
            }
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/FleetVehicleTypesTableService.js